import { render } from "./BiblioTheque.vue?vue&type=template&id=932a71b8&scoped=true&ts=true"
import script from "./BiblioTheque.vue?vue&type=script&lang=ts"
export * from "./BiblioTheque.vue?vue&type=script&lang=ts"

import "./BiblioTheque.vue?vue&type=style&index=0&id=932a71b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-932a71b8"]])

export default __exports__